<div class="container-fluid testimonials-container">
  <!-- Title and Subtitle -->
  <div *ngIf="showTitles" class="row" style="padding: 2rem 0">
    <div class="col-12">
      <h2
        class="titleTextFont font-weight-normal text-center"
        style="font-size: 2.4rem"
        [ngStyle]="{ color: titlesColor ? titlesColor : '' }"
        [ngClass]="{ 'cursor-pointer': hasTitleLink() }"
        (click)="gotToLink()"
      >
        {{ title }}
      </h2>
    </div>
    <div *ngIf="subtitle" class="col-12">
      <h2
        class="font-weight-normal fadeIn text-center mb-3 subtitle-block"
        style="font-size: 1.5rem"
        [ngStyle]="{ color: secondaryColor ? secondaryColor : '' }"
      >
        {{ subtitle }}
      </h2>
    </div>
  </div>

  <!-- Testimonials Slider -->
  <div
    *ngIf="testimonials && testimonials.length > 0"
    class="testimonials-slider"
  >
    <div class="slider-wrapper">
      <div class="slider-track" [style.transform]="getTransform()">
        <div
          *ngFor="let testimony of testimonials; let i = index"
          class="testimony-slide"
          [class.active]="i === currentIndex"
        >
          <div class="testimony-card" (mouseenter)="isHovered = true" (mouseleave)="isHovered = false">
            <!-- Author Image (Left Side) -->
            <div class="author-image-large">
              <img
                [src]="getImage(testimony)"
                [alt]="testimony.name"
                loading="lazy"
                (error)="$any($event.target).src = defaultAvatar"
              />
            </div>

            <!-- Content (Right Side) -->
            <div class="testimony-content-horizontal">
              <div class="author-name-top">{{ testimony.name }}</div>
              <div class="testimony-text-horizontal">{{ testimony.text }}</div>

              <!-- URL Button -->
              <div *ngIf="testimony.url" class="card-button-wrapper">
                <a
                  [href]="testimony.url"
                  class="card-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ testimony.button_text || '' }}
                  <i class="fa fa-arrow-right ms-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation Arrows -->
    <div class="slider-controls">
      <button
        class="nav-arrow prev"
        (click)="prevSlide()"
        [style.border-color]="primaryColor"
        [style.color]="primaryColor"
      >
        <i class="fa fa-chevron-left"></i>
      </button>

      <!-- Dots Indicator -->
      <div class="dots-indicator">
        <span
          *ngFor="let testimony of testimonials; let i = index"
          class="dot"
          [class.active]="i === currentIndex"
          [style.background-color]="
            i === currentIndex ? primaryColor : '#d1d5db'
          "
          (click)="goToSlide(i)"
        ></span>
      </div>

      <button
        class="nav-arrow next"
        (click)="nextSlide()"
        [style.border-color]="primaryColor"
        [style.color]="primaryColor"
      >
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>
  </div>
</div>
